export default function AssignmentForm({
  handleSubmit,
  setSelectedVideo,
  selectedVideo,
  setFormValues,
  formValues,
  videos,
  isForEdit = false,
}) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleVideoSelect = (e) => {
    const { value } = e.target;
    if (!value) {
      setSelectedVideo(null);
      return;
    }

    const selectedVideo = videos.find((video) => video.id === Number(value));
    setSelectedVideo(selectedVideo);
  };

  return (
    <form
      className="mt-8 space-y-6 mx-auto max-w-md px-5 lg:px-0"
      action="#"
      method="POST"
      onSubmit={handleSubmit}
    >
      <h1 className="text-xl text-center font-bold">
        {isForEdit ? "Edit assignment" : "Add assignment"}
      </h1>
      <div className="form-group">
        <label htmlFor="title">Title</label>
        <input
          id="title"
          name="title"
          type="text"
          onChange={handleChange}
          value={formValues.title}
          required
          className="login-input rounded-t-md"
          placeholder="assignment title"
        />
      </div>
      <div className="form-group">
        <label htmlFor="title">Assignment Video</label>
        <select
          name="video"
          id="video"
          className="login-input rounded-t-md"
          required
          onChange={handleVideoSelect}
          value={selectedVideo?.id}
        >
          <option value="" selected>
            select assignment video
          </option>
          {videos?.map((video) => (
            <option value={video.id} key={video.id}>
              {video.title}
            </option>
          ))}
        </select>
      </div>
      <div className="form-group">
        <label htmlFor="totalMark">Total Mark</label>
        <input
          id="totalMark"
          name="totalMark"
          type="number"
          onChange={handleChange}
          value={formValues.totalMark}
          required
          className="login-input rounded-t-md"
        />
      </div>

      <button
        type="submit"
        className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
      >
        Submit
      </button>
    </form>
  );
}
